
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { updateStatusRequest, updateStatusRequestError, updateStatusRequestSuccess } from "../../slices/user-management/UpdateStatusSlice";


export const UpdateStatusAPI =
    (data) => async (dispatch) => {
        try {
            dispatch(updateStatusRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.updateUserStatus,
                data: data,
                headers: { "Content-Type": "application/json" },
            })
            return dispatch(updateStatusRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(updateStatusRequestError(_error));
        }
    };
